import { io } from 'socket.io-client';
import { baseURLIO } from './global/api';

export const socket = io(baseURLIO, {
   // autoConnect: false
});